var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loaded)?_c('div',[_c('chartist',{staticStyle:{"max-height":"125px"},attrs:{"ratio":"ct-major-second","type":"Line","data":_vm.chartData,"options":_vm.chartOptions}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }